import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=5186109c&"
import script from "./CheckBox.vue?vue&type=script&lang=js&"
export * from "./CheckBox.vue?vue&type=script&lang=js&"
import style0 from "./CheckBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CheckBox.vue"
export default component.exports